import dayjs from 'dayjs';
import { useLocale, useTranslations } from 'next-intl';
import { isStayOrFlexible } from 'src/helpers';
import { LOCALE_DATE_FORMAT } from 'src/lib/constants';
import { Option, BookingFormValues, DetailedTimeslot, EnumOptionKind } from 'src/types';

const GetDateAccomPlaceholder: React.FC<{
  option: Option;
  bookingFormValues: BookingFormValues;
  detailedTimeslot?: DetailedTimeslot;
}> = ({ option, bookingFormValues, detailedTimeslot }) => {
  const locale = useLocale();
  const translation = useTranslations('components.GetDateAccomPlaceholder');
  const UIDateFormat = LOCALE_DATE_FORMAT[locale].UIDateFormat

  let dateText: string;
  if (isStayOrFlexible(option)) {
    const dates = [
      bookingFormValues.startDate ? dayjs(bookingFormValues.startDate).format('MMM DD') : '...',
      bookingFormValues.endDate ? dayjs(bookingFormValues.endDate).format('MMM DD') : '...',
    ];
    dateText =
      bookingFormValues.startDate || bookingFormValues.endDate
        ? dates.join(' - ')
        : translation('dates');
  } else {
    dateText =
      [
        bookingFormValues.startDate
          ? dayjs(bookingFormValues.startDate).format(UIDateFormat)
          : null,
        detailedTimeslot
          ? `${dayjs.utc(detailedTimeslot.startTime).format('h:mmA')} - ${dayjs
              .utc(detailedTimeslot.endTime)
              .format('h:mmA')}`
          : null,
      ]
        .filter((v) => v)
        .join(' • ') || translation('startDate');
  }

  let placeholder: string;
  if (!bookingFormValues.startDate && !bookingFormValues.endDate) {
    if (option.kind === EnumOptionKind.shortAdventure) {
      placeholder = translation('dateAndTime');
    } else {
      placeholder = isStayOrFlexible(option) ? translation('dates') : translation('startDate');
    }
  } else {
    placeholder = dateText;
  }

  return <span>{placeholder}</span>;
};

export default GetDateAccomPlaceholder;
